export const routesUrlsData = {
    accounts: "/accounts",
    admin: {
        billing: "/admin/billing",
        dataSources: "/admin/data-sources",
        home: "/admin",
        organizations: "/admin/organizations",
        users: "/admin/users",
    },
    auth: {
        forgetPassword: "/auth/forget-password",
        inviteUser: "/auth/invite-user",
        login: "/auth/login",
        path: "/auth",
        resetPassword: "/auth/reset-password",
        signup: "/auth/signup",
    },
    dataSources: {
        offlineMapping: "/data-sources/offline-mapping",
        path: "/data-sources",
        setup: "/data-sources/setup",
    },
    home: "/",
    ledger: "/ledger",
    notFound: "*",
    organization: {
        apiKeys: "/organization/api-keys",
    },
    profile: "/profile",
    reconciliations: {
        auditLogs: "/audit-logs",
        path: "/reconciliations",
    },
    settings: "/settings",
    users: "/users",
};
